<template>
  <div class="h-8">
    <input
      v-model.trim="text"
      type="text"
      :maxlength="max || undefined"
      :class="[
        'survey-input-textarea w-full resize-none px-2 py-1 outline-none overflow-hidden',
        'rounded-md border border-gray-400',
        'placeholder-gray-400'
      ]"
      :placeholder="placeholder"
    />
  </div>
</template>

<script lang="ts">
import { useVModel } from '@vueuse/core';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SurveyInputText',
  props: {

    /**
     * 入力した文字
     */
    modelValue: {
      type: String,
      default: undefined,
    },

    /**
     * 最大文字数
     */
    max: {
      type: Number,
      default: 0,
    },

    /**
     * プレースホルダ
     */
    placeholder: {
      type: String,
      default: '入力してください',
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(prop) {
    const text = useVModel(prop, 'modelValue');

    return {
      text,
    };
  },
});
</script>
